'use strict';

// Mobile apps controller
angular.module('mobile-apps').controller('TranslationOrderSelect', [
	'$rootScope',
	'$scope',
	'$stateParams',
	'FileUploader',
	'Authentication',
	'$state',
	'TranslationOrder',
	'Utilities',
	'EntryMain',
	function (
		$rootScope,
		$scope,
		$stateParams,
		FileUploader,
		Authentication,
		$state,
		TranslationOrder,
		Utilities,
		EntryMain
	) {
		$scope.authentication = Authentication;
		$scope.mobileAppId = $stateParams.mobileAppId;

		$scope.spreadsheetData = {
			columnTypes: [],
			dataComplete: false,
			includeFirstRow: false
		};

		$scope.data = {
			fileContent: [],
			uploadInProgress: false
		};


		/**
		 * Submit the data
		 */
		$scope.submit = function() {

			if ($scope.spreadsheetData.dataComplete === false) {
				// Should not happen because the button is deactivated in that
				// case but just to be sure.
				return;
			}

			var sendData = {};
			sendData.mobileAppId = $scope.mobileAppId;
			sendData.fileId = $stateParams.fileData.file._id;
			sendData.includeFirstRow = $scope.spreadsheetData.includeFirstRow;
			sendData.columnDescription = {};

			for (var i=0;i<$scope.spreadsheetData.columnTypes.length;i++) {
				var type = $scope.spreadsheetData.columnTypes[i];
				if (type) {
					sendData.columnDescription[type] = i;
				}
			}

			$scope.data.uploadInProgress = true;
			TranslationOrder.translationOrderCreateFromFile(sendData,
				function(response) {
					$scope.data.uploadInProgress = false;
					console.log('GOT DATA');
					console.log(response);

					$state.go('translationOrderView', {
						mobileAppId: $stateParams.mobileAppId,
						orderId: response.order._id
					});
				},
				function(error) {
					Utilities.showMessageErrorResponse(error);
					$scope.data.uploadInProgress = false;
					console.log('GOT ERROR');
					console.log(error);
				}
			);

		};


		/**
		 * Cancel column select and go back to upload page
		 */
		$scope.cancel = function() {
			$state.go('translationOrderUpload', {mobileAppId: $stateParams.mobileAppId});
		};


		/**
		 * Initializes all the data and redirects to previous page if required
		 * data is missing
		 */
		function init() {
			EntryMain.loadMobileApp($scope.mobileAppId, false, function(err, mobileApp) {
				$scope.mobileApp = mobileApp;
			});

			// Check if we got a file else redirect back to upload
			if (!$stateParams.fileData || !$stateParams.fileData.file || !$stateParams.fileData.file.originalName) {
				$state.go('translationOrderUpload', {mobileAppId: $stateParams.mobileAppId});
				console.log('REDIRECTED because no file');
				return;
			}

			if ($stateParams.fileData.content.length === 0) {
				Utilities.showMessage(
					'Error!',
					'The file data is missing. Please try again!',
					'error'
				);
				return;
			}

			for (var i=0;i<$stateParams.fileData.content[0].length;i++) {
				$scope.spreadsheetData.columnTypes[i] = '';
			}

			$scope.data.fileContent = $stateParams.fileData.content;
		}


		init();
	}
]);
